import "./Description.css";

const Description = ({ currentModelDescription }) => {
  return (
    <div className="description">
      <p className="description-text-bold">Model description:</p>
      <p className="description-text">{currentModelDescription}</p>
    </div>
  );
};

export default Description;
